import { convertViewingStreamForES } from '@/appLogic/targets/conversions'

export const SET_TARGET_DEFINITION_DIRTY = 'SET_TARGET_DEFINITION_DIRTY'
export const SET_IS_DROPPED = 'SET_IS_DROPPED'
export const SET_METRICS = 'SET_METRICS'
export const SET_LOADING = 'SET_LOADING'
export const SET_SAVING = 'SET_SAVING'
export const SET_FETCHING_TARGET = 'SET_FETCHING_TARGET'
export const SET_FETCHING_WORKBENCH_DATA = 'SET_FETCHING_WORKBENCH_DATA'
export const SET_QUICK_ADD = 'SET_QUICK_ADD'
export const SET_STREAMING_OPTION = 'SET_STREAMING_OPTION'
export const SHOW_TARGET_HISTORY_PANEL = 'SHOW_TARGET_HISTORY_PANEL'
export const FLAG_REQUEST_NUMBER = 'FLAG_REQUEST_NUMBER'

export default {
  [SET_TARGET_DEFINITION_DIRTY] (state, value) {
    state.dirty = value
  },
  [SET_IS_DROPPED] (state, value) {
    state.isDropped = value
  },
  [SET_FETCHING_TARGET] (state, value) {
    state.fetchingTarget = value
  },
  [SET_FETCHING_WORKBENCH_DATA] (state, value) {
    state.fetchingWorkbenchData = value
  },
  [SET_LOADING] (state, value) {
    state.loading = value
  },
  [SET_SAVING] (state, value) {
    state.saving = value
    if (state.saving) {
      state.lastTimeSaved = new Date()
    }
  },
  [SET_METRICS] (state, value) {
    state.metrics = value
  },
  [SET_QUICK_ADD] (state, value) {
    state.quickAddAttributes = value
  },
  [SET_STREAMING_OPTION] (state, value) {
    state.streamingOption = convertViewingStreamForES(value)
  },
  [SHOW_TARGET_HISTORY_PANEL] (state, value) {
    state.showTargetHistoryPanel = value
  },
  [FLAG_REQUEST_NUMBER] (state) {
    state.requestNumber = state.requestNumber + 1
  }
}



// WEBPACK FOOTER //
// ./src/app/views/workbenchCanvas/store/mutations.js